import { styled } from '@mui/material/styles';
import {TextField } from "@mui/material";

export const HighlightedTextField = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: theme.palette.secondary.main, // Secondary color outline always
        },
        '&:hover fieldset': {
            borderColor: theme.palette.secondary.main, // Secondary color outline on hover
        },
        '&.Mui-focused fieldset': {
            borderColor: theme.palette.secondary.main, // Secondary color outline when focused
        },
    },
    '& .MuiInputBase-input': {
        color: theme.palette.secondary.main, // Secondary color input text
    },
    '& .MuiFormLabel-root': {
        color: theme.palette.secondary.main, // Secondary color label text
    },
    '& .MuiFormLabel-root.Mui-focused': {
        color: theme.palette.secondary.main, // Secondary color label text when focused
    },
    '& .MuiFormHelperText-root': {
        color: theme.palette.secondary.main, // Secondary color helper text
    },
}));